import React, { Component } from "react";
import {
    Typography,
    Grid,
    Button,
    List,
    ListItem,
} from "@material-ui/core";
import styled from "styled-components";
import {
    StyledCard,
    StyledHeader
} from "../../styles";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
const StyledListItem = styled(ListItem)`
    background: white;
    border: 1px solid #ddd;
    border-radius: 0px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 24px;
    border-left: 4px solid ${(props) => props.borderColor};
    :first & {
        margin-top: 0px;
    }
`;
export default class JobPackAttachedPhotos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: props.profile,
            edit: props.edit,
            selectedPhoto: false,
            selectedPhotoModal: false,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }

    render() {
        const { profile } = this.state;
        return (
            <StyledCard style={{ border: "1px solid #0188cc", borderWidth: "2px", borderRadius: "6px" }}>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography style={{ color: "white", fontSize: "20px", textAlign: "center" }}>
                        Jobpack Media
                    </Typography>
                </StyledHeader>
                <br />
                <br />
                <div>
                    <List style={{ marginLeft: "10px" }}>
                        <Typography
                            style={{
                                marginBottom: 30,
                                color: "#0188CC",
                                textAlign: "left",
                                float: "left",
                                fontSize: "18px",
                                fontWeight: "bold"
                            }}
                        >
                            Jobpack Voice Recordings:
                        </Typography>
                        {profile.attached_recordings && profile.attached_recordings
                            .map((e, index) => {
                                return (
                                    <StyledListItem
                                        borderColor={"#0188cc"}
                                        style={{
                                            root: {
                                                borderLeft: "#0188cc",
                                            },
                                        }}
                                    >
                                        <Grid container spacing={4}>
                                            <Grid item sm={12} md={12} lg={2} xl={2}>
                                                <Typography
                                                    variant="body2"
                                                    style={{ paddingLeft: 24, paddingTop:"30px" }}
                                                >
                                                    {e.recording_name}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={12} md={12} lg={2} xl={2}>

                                                <Typography
                                                    variant="body2"
                                                    style={{ paddingLeft: 24, paddingTop:"30px" }}
                                                >
                                                    {e.recording_timestamp}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={12} md={12} lg={8} xl={8}>
                                                <AudioPlayer
                                                    autoPlay = {false}
                                                    src={e.recording_url}
                                                    onPlay={e => console.log("onPlay")}
                                                    
                                                // other props here
                                                />
                                            </Grid>
                                        </Grid>
                                    </StyledListItem>
                                );
                            })}
                    </List>
                </div>
                <br />
                <div style={{ marginLeft: "10px" }}>
                    <Typography
                        style={{
                            marginBottom: 30,
                            color: "#0188CC",
                            textAlign: "left",
                            float: "left",
                            fontSize: "18px",
                            fontWeight: "bold"
                        }}
                    >
                        Site Photos:
                </Typography>
                    <Grid container>
                        {profile.attached_photos &&
                            profile.attached_photos.map((e) => {
                                return (
                                    <Grid item lg={2} md={2} sm={2} xs={2}>
                                        <img
                                            src={e.photo_url}
                                            alt={e.timestamp}
                                            style={{

                                                height: "115px",
                                                width:"158px",
                                                cursor: "pointer",
                                                border: "4px solid #0188cc",
                                                borderWidth: "2px",
                                                borderRadius: "6px",
                                                marginTop:"5px"
                                            }}
                                            onClick={() => {
                                                this.setState({
                                                    selectedPhoto: e,
                                                    selectedPhotoModal: true,
                                                });
                                            }}
                                        />
                                        <Typography variant="body2" style={{ marginTop: "3px" }}>
                                            <b>Name:</b>{" "}
                                            {e.photo_name}
                                            <br />
                                            <b>Timestamp:</b>
                                            {e.photo_timestamp}
                                        </Typography>
                                    </Grid>
                                );
                            })}
                    </Grid>
                </div>
                <br />
                <div style={{ marginLeft: "10px" }}>
                    <Typography
                        style={{
                            marginBottom: 30,
                            color: "#0188CC",
                            textAlign: "left",
                            float: "left",
                            fontSize: "18px",
                            fontWeight: "bold"
                        }}
                    >
                        Attached Sketches:
                </Typography>
                    <Grid container>
                        {profile.attached_sketches &&
                            profile.attached_sketches.map((d) => {
                                return (
                                    <Grid item lg={2} md={2} sm={2} xs={2}>
                                        <img
                                            src={d.photo_url}
                                            alt={d.timestamp}
                                            style={{
                                                height: "230px",
                                                width:"168px",
                                                cursor: "pointer",
                                                border: "4px solid #0188cc",
                                                borderWidth: "2px",
                                                borderRadius: "6px",
                                                marginBottom: "5px"
                                            }}
                                            onClick={() => {
                                                this.setState({
                                                    selectedPhoto: d,
                                                    selectedPhotoModal: true,
                                                });
                                            }}
                                        />
                                        <Typography variant="body2" style={{ marginTop: "3px" }}>
                                            <b>Name:</b>{" "}
                                            {d.photo_name}
                                            <br />
                                            <b>Timestamp:</b>
                                            {d.photo_timestamp}
                                        </Typography>
                                    </Grid>
                                );
                            })}
                    </Grid>
                </div>
                <br />
                <Modal isOpen={this.state.selectedPhotoModal}>
                    <ModalHeader>View Attached Image</ModalHeader>
                    {this.state.selectedPhoto && (
                        <ModalBody>
                            <Typography variant="body2">
                                <b>Name:</b>{" "}
                                {this.state.selectedPhoto.photo_name}
                                <br />
                                <b>Timestamp:</b>
                                {this.state.selectedPhoto.photo_timestamp}
                            </Typography>
                            <img
                                src={this.state.selectedPhoto.photo_url}
                                alt={this.state.selectedPhoto.photo_timestamp}
                                style={{
                                    width: "100%",
                                    height: "auto",
                                }}
                            />
                        </ModalBody>
                    )}
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() =>
                                    this.setState({
                                        selectedPhoto: false,
                                        selectedPhotoModal: false,
                                    })
                                }
                            >
                                Close
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </StyledCard>
        );
    }
}
